import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Alert, AlertService, AlertType } from '@michelin/theme';
import { PasswordResetService } from 'src/app/shared/services/auth/password-reset.service';

@Component({
    selector: 'app-password',
    templateUrl: './password.component.html',
    styleUrl: './password.component.scss',
    standalone: false
})
export class PasswordComponent {
  hide = true;
  image = true;
  loading = false;
  emailSent = false;
  loginForm: FormGroup = null;

  constructor(
    private readonly form: FormBuilder,
    private readonly alertService: AlertService,
    private readonly passwordResetService: PasswordResetService
  ) {
    this.loginForm = this.form.group({
      username: this.form.control('', [Validators.required])
    });
  }

  recoverPassword() {
    if (this.loginForm.valid) {
      this.loading = true;
      this.passwordResetService
        .requestPasswordReset(this.loginForm.value['username'])
        .subscribe({
          next: () => {
            this.alertService.showAlert({
              type: AlertType.success,
              title: 'O Link para redefinição da senha foi enviado para o e-mail cadastrado'
            } as Alert);
            this.emailSent = true;
          },
          error: () =>
            this.alertService.showAlert({
              type: AlertType.critical,
              title: 'Ocorreu um erro ao processar a solicitação'
            } as Alert)
        })
        .add(() => (this.loading = false));
    } else {
      this.alertService.showAlert({
        type: AlertType.strong,
        title: 'Preencha o usuário cadastrado'
      } as Alert);
    }
  }
}
